export const getAddress = () => {
  return '서울특별시 강남구 테헤란로86길 13 (대경타워 5층)'
}

export const getContactPoint = () => {
  return '1644-5060'
}

export const getKakaoChannelUrl = () => {
  return 'https://bizmessage.kakao.com/chat/open/@더낸세금'
}
